import { Navigate, Routes, Route } from 'react-router-dom';
import Login from './pages/Login';
import AdminDashboard from './pages/AdminDashboard';
import Users from './pages/Users';
import Settings from './pages/Settings';
import Notifications from './pages/Notifications';
import Reports from './pages/Reports';
import Support from './pages/Support';
import SupportIssuesBoard from './pages/SupportIssuesBoard';
import AdminMessaging from './pages/AdminMessaging'; 
import MessageOversight from './pages/MessageOversight';
import Subjects from './pages/Subjects';
import AdminLad from './pages/AdminLad';
import AdminRecordings from './pages/Recording';
import Announcements from './pages/Announcements';
import MathClasses from './pages/MathClasses';
import MatricClasses from './pages/MatricClasses';
import MatricIntakes from './pages/MatricIntakes';
import Reviews from './pages/Reviews';
import Bookings from './pages/Bookings';
import DiscountCodes from './pages/DiscountCodes';
import TutorImports from './pages/TutorImports';
import TutorCapabilities from './pages/TutorCapabilities';
import LessonAlerts from './pages/LessonAlerts';
import InPersonReconciliation from './pages/InPersonReconciliation';
import Billing from './pages/Billing';
import BoardLogin from './pages/BoardLogin';
import Workboards, { BoardAccessGuard, BoardGuard, BoardPassword, LegacyAdminGuard } from './pages/Workboards';
import AdminPasswordChange, {
  PasswordChangeOnly,
  RequireAdminPasswordReady,
} from './pages/AdminPasswordChange';
const BILLING_UI_ENABLED = String(process.env.REACT_APP_BILLING_MODULE_ENABLED || '').toLowerCase() === 'true';

function App() {
  const legacy = (Component) => <LegacyAdminGuard><Component /></LegacyAdminGuard>;
  const admin = (Component) => (
    <RequireAdminPasswordReady>{legacy(Component)}</RequireAdminPasswordReady>
  );
  return (
    <Routes>
      <Route path="/" element={<Login />} />
      <Route path="/admin/change-password" element={<PasswordChangeOnly><AdminPasswordChange /></PasswordChangeOnly>} />
      <Route path="/admin" element={admin(AdminDashboard)} />
      <Route path="/admin/subjects" element={admin(Subjects)} />
      <Route path="/admin/analytics" element={admin(AdminLad)} />
      <Route path="/admin/announcements" element={admin(Announcements)} />
      <Route path="/admin/notifications" element={admin(Notifications)} />
      <Route path="/admin/reports" element={admin(Reports)} />
      <Route path="/admin/support" element={admin(Support)} />
      <Route path="/admin/users" element={admin(Users)} />
      <Route path="/admin/bookings" element={admin(Bookings)} />
      {BILLING_UI_ENABLED && <Route path="/admin/billing" element={admin(Billing)} />}
      {BILLING_UI_ENABLED && <Route path="/admin/billing/operations" element={admin(Billing)} />}
      {BILLING_UI_ENABLED && <Route path="/admin/billing/paid" element={admin(Billing)} />}
      {BILLING_UI_ENABLED && <Route path="/admin/billing/new" element={admin(Billing)} />}
      {BILLING_UI_ENABLED && <Route path="/admin/billing/:invoiceId" element={admin(Billing)} />}
      <Route path="/admin/discount-codes" element={admin(DiscountCodes)} />
      <Route path="/admin/lesson-alerts" element={admin(LessonAlerts)} />
      <Route path="/admin/in-person-reconciliation" element={admin(InPersonReconciliation)} />
      <Route path="/admin/tutor-imports" element={admin(TutorImports)} />
      <Route path="/admin/tutor-capabilities" element={admin(TutorCapabilities)} />
      <Route path="/admin/reviews" element={admin(Reviews)} />
      <Route path="/admin/math-classes" element={admin(MathClasses)} />
      <Route path="/admin/matric-classes" element={admin(MatricClasses)} />
      <Route path="/admin/matric-intakes" element={admin(MatricIntakes)} />
      <Route path="/admin/settings" element={admin(Settings)} />
      <Route path="/admin/messages" element={admin(AdminMessaging)} />
      <Route path="/admin/message-oversight" element={admin(MessageOversight)} />
      <Route path="/admin/recordings" element={admin(AdminRecordings)} />
      <Route path="/admin/*" element={<Navigate to="/admin" replace />} />
      <Route path="/boards/login" element={<BoardLogin />} />
      <Route path="/boards/change-password" element={<BoardGuard><BoardPassword /></BoardGuard>} />
      <Route path="/boards/support" element={<BoardAccessGuard><SupportIssuesBoard /></BoardAccessGuard>} />
      <Route path="/boards/:board" element={<BoardAccessGuard><Workboards /></BoardAccessGuard>} />
    </Routes>
  );
}

export default App;











